import React, { useEffect, useRef, useState } from 'react';

const CATEGORIES = [
  { key: 'all', label: 'Todos', icon: 'ti-layout-2' },
  { key: 'image', label: 'Imagens', icon: 'ti-photo' },
  { key: 'video', label: 'Vídeos', icon: 'ti-player-play' },
  { key: '3d', label: 'Modelos 3D', icon: 'ti-box' },
  { key: 'game', label: 'Game Assets', icon: 'ti-device-gamepad-2' }
];
const SENSITIVE_JOKES = ['Modo Banana 🍌', 'Estranhamente sério', 'A gaveta suspeita', 'Depois da meia-noite', 'Pimenta nos olhos'];

function Sidebar({ activeType, onSelectType, counts, hidden, showSensitive, onToggleSensitive }) {
  const [sensitiveLabel,setSensitiveLabel]=useState(SENSITIVE_JOKES[0]);
  const previousHidden=useRef(true);
  useEffect(()=>{
    if(previousHidden.current&&!hidden)setSensitiveLabel(current=>{
      const choices=SENSITIVE_JOKES.filter(item=>item!==current);
      return choices[Math.floor(Math.random()*choices.length)];
    });
    previousHidden.current=hidden;
  },[hidden]);
  return (
    <aside
      className={`flex-none flex flex-col gap-1 py-5 px-3.5 border-r transition-all overflow-y-auto sticky max-md:fixed max-md:left-0 ${hidden ? 'w-0 opacity-0 pointer-events-none border-r-0 px-0' : 'w-[220px]'}`}
      style={{
        top: '57px',
        height: 'calc(100vh - 57px)',
        borderRightColor: 'var(--glass-border)',
        backgroundImage: hidden ? 'none' : 'linear-gradient(180deg, rgba(7,6,10,.42), rgba(7,6,10,.66)), url(/blop_anime.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: 40
      }}
      data-testid="sidebar"
    >
      <div className="text-[11px] font-semibold text-white/50 uppercase tracking-wider px-2 pt-4 pb-1.5" style={{textShadow:'0 2px 4px rgba(0,0,0,0.5)'}}>
        Categorias
      </div>
      {CATEGORIES.map(cat => {
        const isActive = activeType === cat.key;
        const count = counts?.[cat.key];
        return (
          <button
            key={cat.key}
            onClick={() => onSelectType(cat.key)}
            data-testid={`sidebar-${cat.key}`}
            className={`sidebar-category flex items-center gap-3 px-3 py-2.5 text-sm font-medium cursor-pointer transition-all hover:translate-x-[2px] ${
              isActive ? 'text-white font-semibold' : 'text-white/80 hover:text-white'
            }`}
            style={{
              '--category-accent': isActive ? 'var(--accent)' : 'rgba(217,172,91,.48)',
              '--category-glow': isActive ? 'rgba(157,123,230,.28)' : 'rgba(32,24,20,.58)'
            }}
          >
            <i className={`ti ${cat.icon} text-base w-[18px] text-center`}></i>
            <span className="flex-1 text-left">{cat.label}</span>
            {cat.key === 'all' && count !== undefined && (
              <span className="text-[11px] font-semibold text-white px-1.5 py-0.5 rounded-md" style={{background:'var(--accent)'}}>
                {count}
              </span>
            )}
          </button>
        );
      })}
      <button
        onClick={onToggleSensitive}
        data-testid="sidebar-sensitive"
        className={`sidebar-category sidebar-sensitive flex items-center gap-3 px-3 py-2.5 text-sm font-medium cursor-pointer transition-all hover:translate-x-[2px] ${showSensitive?'active text-white font-semibold':'text-white/80 hover:text-white'}`}
        style={{'--category-accent':showSensitive?'#ef8ea1':'rgba(217,172,91,.48)','--category-glow':showSensitive?'rgba(181,54,84,.25)':'rgba(32,24,20,.58)'}}
      >
        <i className={`ti ${showSensitive?'ti-eye':'ti-eye-off'} text-base w-[18px] text-center`}></i>
        <span className="flex-1 text-left"><b>{sensitiveLabel}</b><small>conteúdo sensível +18</small></span>
      </button>
    </aside>
  );
}

export default Sidebar;
